const S3_BASE_URL = "https://jazr-public.s3.eu-central-1.amazonaws.com";
const VERSION = "v1.0.3";

const s3Url = (path: string) => `${S3_BASE_URL}/${path}?v=${VERSION}`;

export const AWS_URLS = {
  IMPORT_ADJUSTMENTS: s3Url("Import-Adjustments.csv"),
  IMPORT_ITEMS: s3Url("Import-Items.csv"),
  IMPORT_STOCKTAKING: s3Url("Import-Stocktaking.csv"),
  IMPORT_STOCKTAKING_NO_RECIPE: s3Url("Import-Stocktaking-No-recipe.csv"),
  PURCHASING_EXCEL: s3Url("Purchasing-Excel.csv"),
  MENU_PRODUCTS: s3Url("template-products-import.csv"),
  MENU_MODIFIERS: s3Url("template-Modifier-import.csv"),
  MENU_PRODUCT_RECIPE: s3Url("template-Product-Recipe.csv"),
  MENU_MODIFIER_RECIPE: s3Url("template-Modifiers-Recipe.csv"),
  PRODUCT_SALE_TEMPLATE: s3Url("product-sale-template.csv"),
  EXCEL_SALE_TEMPLATE: s3Url("excel-sale-template.csv"),
};
